import React from 'react';
import { Section, preloader } from 'spectacle-ppa';

import balloonSlide from '../../baseSlides/balloonSlide';

import MarkdownScript from 'helpers/markdownScript';
import markdownFile from './overview.md';

import apprenticePointingUp from '../../images/characters/apprenticePointingUp.png';

const md = new MarkdownScript(markdownFile);

export function preloadGameShow () {
  preloader([
    apprenticePointingUp
  ]);
}

function overviewSection ({ regionData }) {
  return (
    <Section id="overview">

    {balloonSlide({
      id: 'contents',
      characterSide: 'right',
      characterImage: apprenticePointingUp,
      notes: md.getSubSectionAsHtml('Overview', 'Notes', false, regionData),
      html: md.getSubSectionAsHtml('Overview', 'Content', false, regionData)
    })}

    </Section>
  );
}

export default overviewSection;



// WEBPACK FOOTER //
// ./programs/epsHybridAssembly/sections/04_overview/overviewSection.jsx